import React,{FC} from 'react';
import { PreferenceCard } from './PreferenceCard';
import "./PreferenceCardContainer.scss";
import axios from 'axios';
import { Page } from '../../../CommonUtils/Enums';
import AppService from '../../../CommonUtils/AppService';
import { PropsType } from './PreferenceCardContainerTypes';
import { profileModel, TerminalprofileModel } from '../../../CommonUtils/Functions';
import { ModuleTypeNames } from '../../../CommonUtils/Enums';
import { fireAlert } from '../../../CommonUtils/AlertUtils';
import {useRecoilValue,useSetRecoilState} from "recoil";
import { configurationListAtom,ConfigurationListAtomDefaultValue ,pageNameAtom,profileDetailsAtom ,profileDetailsAtomDefaultValue,registrationTokenAtom,jsonDataAtom,jsonDataAtomDefaultValue, ConfigurationListItemType, JsonDataAtomtype, preferenceCardAtom, ProfileDetailsType, tokenAtom } from '../../../Recoil State/Atoms/PageAtoms';
import { spinnerOverlayAtom } from '../../../Recoil State/Atoms/AppAtoms';
import { AppTypeName } from '../../../Recoil State/ConstantKeys';
import Swal from 'sweetalert2';

export const PreferenceCardContainer:FC <PropsType> = ({heading}) => {

  const profileDetailsState=useRecoilValue(profileDetailsAtom);
  const jsonDataState=useRecoilValue(jsonDataAtom);
  const preferenceCardState=useRecoilValue(preferenceCardAtom);

  const registrationTokenSetter = useSetRecoilState(registrationTokenAtom);
  const configurationListSetter = useSetRecoilState(configurationListAtom);
  const pageNameSetter= useSetRecoilState(pageNameAtom);
  const spinnerOverlaySetter= useSetRecoilState(spinnerOverlayAtom);
  const jsonDataSetter = useSetRecoilState(jsonDataAtom);
  const profileDetailsSetter = useSetRecoilState(profileDetailsAtom);
   const token = useRecoilValue(tokenAtom);


  const GetAllLicenseByInstance = async () => {
    spinnerOverlaySetter({ displayOverlay: true, displaySpinner: true });
    AppService.headerRequestFormat = { ...AppService.headerRequestFormat, headers: { ...AppService.headerRequestFormat.headers, "Authorization": `Bearer ${token}`, }, };
    try {
      var output = {};
      let result: { key: {}; list: any; };
      const response = await axios.post(AppService.getAllLicenseByInstanceURL, "", AppService.headerRequestFormat);
      if (response.data.length > 0) {
        response.data.sort((a, b) => a.LicenseProfileName.localeCompare(b.LicenseProfileName)).forEach(function (item) {
          output[item.LicenseProfileName] = `${item.LicenseProfileName} (${item.UsedLicenseCount}/${item.LicenseCount})`;
        });
        result = { key: output, list: response.data };
        spinnerOverlaySetter({ displayOverlay: false, displaySpinner: false });
        return result;
      }
    } catch (error) {
      spinnerOverlaySetter({ displayOverlay: false, displaySpinner: false, });
      return null;
    }
  };

  const cardClickHandler = async (moduleTypeNames: Array<string>, isActive: boolean) => {
    if (moduleTypeNames[0] == ModuleTypeNames.Terminal) {
      let response = await GetAllLicenseByInstance();
      Swal.fire(({
        title: 'Select an app to install',
        text: 'Ex:- License name (Used count / Total count)',
        input: 'select',
        inputOptions: response.key,
        reverseButtons: true,
        inputPlaceholder: 'Select',
        showCancelButton: true,
        customClass:{"popup":'popup-gridcontainer'},
        inputValidator: async (value) => {
          return new Promise((resolve: any) => {
            if (value && value != "") {
              resolve()
            } else {
              resolve('Please select an app to install')
            }
          })
        },
        didOpen: () => {
          const selectEl = Swal.getInput();
          if (selectEl && selectEl instanceof HTMLSelectElement) {
            Array.from(selectEl.options).forEach((option, index) => {
              if (
                option.label !== "Select" &&
                response.list[index - 1]?.UsedLicenseCount === response.list[index - 1]?.LicenseCount
              ) {
                option.disabled = true;
                option.style.opacity = "0.3";
              } else {
                option.style.color = "black";
              }
            });
          }
        }
      })).then(async (result) => {
        if (result.isConfirmed) {
          let TerminalAppTypeName = "";
          var RegisterationKeyDetails = response?.list.find((item) => item.LicenseProfileName == result.value);
          let SubLicenseInfo = RegisterationKeyDetails?.SubLicenseInfo ? JSON.parse(RegisterationKeyDetails?.SubLicenseInfo) : null;
          let TerminalAppTypeId = 4;
          if (SubLicenseInfo) {
            const configGroup = SubLicenseInfo.find((group) => group.GroupName === "Configuration");
            const keysArray = configGroup?.Keys || configGroup?.keys;
            TerminalAppTypeId = Number(keysArray.find((key) => key.KeyName === "AppType").KeyValue);
          }
          switch (TerminalAppTypeId) {
            case 1:
              TerminalAppTypeName = AppTypeName.Hybrid
              break;
            case 2:
              TerminalAppTypeName = AppTypeName.Terminal
              break;
            case 3:
              TerminalAppTypeName = AppTypeName.Kiosk
              break;
            case 4:
              TerminalAppTypeName = RegisterationKeyDetails.AppType
              break;
            default:
              TerminalAppTypeName = AppTypeName.Terminal
              break;
          }
          TerminalAppTypeName = TerminalAppTypeName;
           if (moduleTypeNames[0] == ModuleTypeNames.Terminal) {
          TerminalCardHandler(moduleTypeNames,isActive,RegisterationKeyDetails.Id, RegisterationKeyDetails.AppType, TerminalAppTypeName);
           }
        }
      })
    }
    else {
      cardClickMethod(moduleTypeNames, isActive);
    }
  }

  const getConfigurationAvailableList = (setConfigListJsonData: any) => {
    /*Api call to get the list of configurations available */
    axios.post(AppService.configListUrl, AppService.configListRequest, AppService._headerRequestFormat)
      .then((response) => {
        let framedResponse = [];
        framedResponse = response?.data?.map((data) => { return { ConfigurationId: data.ConfigurationId, Name: data.Name, value: data.Name, label: data.Name } });
        setConfigListJsonData(framedResponse);
      })
      .catch((err) => {
        setConfigListJsonData([]);
      })
  }

  const TerminalCardHandler = (moduleTypeNames: Array<any>, isActive: boolean,RegisteredLicenseId?:string, AppType?: string, TerminalAppTypeName?: string) => {
    if (!isActive) return;
    const setConfigListJsonData = (framedConfigListResponse: Array<ConfigurationListItemType>) => {
      let updatedJsonDataState: JsonDataAtomtype = JSON.parse(JSON.stringify(jsonDataState));
      /* Terminal flag should be true only if user selects IG Terminal App as a preference */
      updatedJsonDataState.Terminal = "true";
      for (let moduleTypeName of moduleTypeNames) {
       let userProfileData:ProfileDetailsType = profileDetailsState.find(data => data.ModuleTypeName === moduleTypeName);
        updatedJsonDataState?.License?.Modules.push(TerminalprofileModel(userProfileData,RegisteredLicenseId,AppType,TerminalAppTypeName));
      }

      configurationListSetter([...ConfigurationListAtomDefaultValue, ...framedConfigListResponse]);
      jsonDataSetter(updatedJsonDataState);

      /*Import configuration Page navigation */
      spinnerOverlaySetter({ displayOverlay: false, displaySpinner: false })
      pageNameSetter(Page.ImportConfiguration);
    }
    getConfigurationAvailableList(setConfigListJsonData);
  }

  const cardClickMethod = (moduleTypeNames: Array<string>, isActive: boolean) => {
    if (!isActive) return;
    spinnerOverlaySetter({ displayOverlay: true, displaySpinner: true })

    const setConfigListJsonData = (framedConfigListResponse: Array<ConfigurationListItemType>) => {
      let updatedJsonDataState: JsonDataAtomtype = JSON.parse(JSON.stringify(jsonDataState));

      /* Adding the selected profile to JSON only if it's not the interface server */
      if (moduleTypeNames[0] !== ModuleTypeNames.InterfaceServer) {
        for (let moduleTypeName of moduleTypeNames) {
          let userProfileData = profileDetailsState.find(data => data.ModuleTypeName === moduleTypeName);
          updatedJsonDataState?.License?.Modules.push(profileModel(userProfileData));
        }
      }
      configurationListSetter([...ConfigurationListAtomDefaultValue, ...framedConfigListResponse]);
      jsonDataSetter(updatedJsonDataState);

      /*Import configuration Page navigation */
      spinnerOverlaySetter({ displayOverlay: false, displaySpinner: false })
      pageNameSetter(Page.ImportConfiguration);
    }
    getConfigurationAvailableList(setConfigListJsonData);
  }

  const backClickHandler=()=>{
    try{
      spinnerOverlaySetter({
        displayOverlay:true,
        displaySpinner:true,
      })

      const confirmButtonHandler=()=>{
        pageNameSetter(Page.DeviceRegistration);
        registrationTokenSetter({registrationKey:"",token:""});
        configurationListSetter(ConfigurationListAtomDefaultValue);
        
        jsonDataSetter(jsonDataAtomDefaultValue);
        profileDetailsSetter(profileDetailsAtomDefaultValue);

        spinnerOverlaySetter({
          displayOverlay:false,
          displaySpinner:false,
        })

      }

      const cancelButtonHandler=()=>{
        spinnerOverlaySetter({
          displayOverlay:false,
          displaySpinner:false,
        })
      }

      /* Prompt */
      fireAlert(
        {icon:"warning",text:"Going back will remove the license key details previously entered. Do you still want to proceed?",showCancelButton:true,showConfirmButton:true,cancelButtonText:"No",confirmButtonText:"Yes",confirmButtonHandler:confirmButtonHandler,cancelButtonHandler:cancelButtonHandler},
        {container: 'custom-alert-container',
        popup: 'custom-alert-popup',
        titleClass: 'custom-alert-title',
        closeButton: 'custom-alert-close-button',
        iconClass: 'custom-alert-icon',
        confirmButton: 'custom-alert-confirm-button',
        cancelButton: 'custom-alert-cancel-button',
        footer: 'custom-alert-footer',
        }
      )
      
    }
    catch(err){
      
    }
  };

  return (
    <>
    <h1 className="content-heading">{heading}</h1>
    <div className="preference-card-wrapper">
      <div className="preference-card-container">
        {
            preferenceCardState?.map((data,index)=>{
                return (<PreferenceCard heading={data.heading} description={data.description} key={index} img={data.img} moduleTypeNames={data.moduleTypeNames} cardClickHandler={cardClickHandler} shouldDisplay={data.shouldDisplay}/>)
            })
        }
      </div>
      <div className="preference-card-button-container">
        <button type="button" className="preference-card-backbutton" onClick={backClickHandler}>Back</button>
      </div>
      
    </div>
    </>
    
    
  )
}
